import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { Box, TextAlpha } from '@yonderland/andes-react';
import { connect } from 'react-redux';
import { makeGetProductFulfillment, makeGetProductFulfillmentBySize, } from '../../redux/product/selectors/ProductSelector';
const ProductFulfillmentContainer = ({ fulfillment: { ccExcluded, hdExcluded, fulfillmentCopyDescription }, fulfillmentBySize: { storeSourceExcluded }, }) => {
    const { checkoutCc: clickAndCollectEnabled } = useAemConfig();
    const availableInStoreOnly = ccExcluded && (hdExcluded || storeSourceExcluded);
    if (!availableInStoreOnly || !clickAndCollectEnabled) {
        return null;
    }
    return (_jsx(Box, { paddingBlockStart: "4", children: _jsx(TextAlpha, { as: "span", children: fulfillmentCopyDescription }) }));
};
const makeMapStateToProps = () => {
    const getProductFulfillment = makeGetProductFulfillment();
    const getProductFulfillmentBySize = makeGetProductFulfillmentBySize();
    const mapStateToProps = (state) => ({
        fulfillment: getProductFulfillment(state),
        fulfillmentBySize: getProductFulfillmentBySize(state),
    });
    return mapStateToProps;
};
export default connect(makeMapStateToProps)(ProductFulfillmentContainer);
